import { useState, MouseEvent } from 'react';

type ToggleParam = boolean | MouseEvent;

const useToggle = (
  initialState = false
): [boolean, (val?: ToggleParam) => void] => {
  const [state, setState] = useState<boolean>(initialState);
  const toggle = (val?: ToggleParam): void =>
    setState(val !== undefined && typeof val === 'boolean' ? val : !state);

  return [state, toggle];
};

export default useToggle;
